module.exports = __webpack_public_path__ + "static/netflix-ccxp-4-43a5eee2719730b3eedeb53fc499b812.jpg";